// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list_menu":"list_menu-1MYER6ue","morehNew":"morehNew-1CSDHKIa","more":"more-2Gb02QRI"};